interface EmailProps {
  className?: string;
}

export default function Email({ className }: EmailProps) {
  return (
    <svg
      className={className}
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5 19.5L14.8571 11.8182M9.14286 11.8182L1.5 19.5M1.5 4.5L10.1649 12.7938C10.8261 13.4249 11.1567 13.7405 11.5163 13.8627C11.8339 13.9707 12.1661 13.9707 12.4837 13.8627C12.8433 13.7405 13.1739 13.4249 13.8351 12.7938L22.5 4.5M2 20H22C22.5523 20 23 19.5523 23 19V5C23 4.44772 22.5523 4 22 4H2C1.44772 4 1 4.44772 1 5V19C1 19.5523 1.44772 20 2 20Z"
        stroke="#2C2C2C"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
